module.exports = __webpack_public_path__ + "assets/img/lvding.1f5478e4.png";